import SEO from '@/components/SEO';
import { UnifiedProfessionalDirectory } from '@/components/UnifiedProfessionalDirectory';

export default function CapsDirectory() {
  return (
    <>
      <SEO
        title="CAPS Specialists Directory"
        description="Find Certified Aging-in-Place Specialists (CAPS) in the SeniorThrive network. Browse specialists, service areas, and contact details."
        keywords="CAPS, certified aging in place specialist, home modifications, accessibility, aging in place, specialist directory"
        canonical="https://seniorthrive.com/caps-specialists/directory"
      />
      
      <UnifiedProfessionalDirectory 
        professionType="CAPS"
        title="CAPS Specialists Directory"
        description="Browse certified aging-in-place specialists in the SeniorThrive network."
      />
    </>
  );
}